module.exports = __webpack_public_path__ + "img/notes-to-financial-statements.5cfdf5dd.jpg";